import { createPendientesPage, defaultSortRows, ESTATUS2_SELECT_FIELD_OPTIONS } from "./PendientesLocalPage";

const normalizeLocalidad = (value) => (value ?? "").toString().trim().toLowerCase();

const filterForaneoRows = (rows) => {
  if (!Array.isArray(rows)) return [];
  const filtered = rows.filter(row => !/multiasistencia|qualitas|xnuup|xnuub/.test(String(row?.ASEGURADORA ?? "").toLowerCase()) && normalizeLocalidad(row?.LOCALIDAD) === "foraneo");
  return defaultSortRows(filtered);
};

const PendientesForaneoPage = createPendientesPage({
  pageTitle: "INPART FOR\u00c1NEO",
  pageSubtitle: "Registros correspondientes a INPART FOR\u00c1NEO.",
  filterBaseRows: filterForaneoRows,
  exportFilePrefix: "pendientes-foraneo",
  exportSheetName: "INPART FOR\u00c1NEO",
  columnVisibilityStorageKey: "baseDatosColumnVisibility-foraneo",
  hiddenColumnFields: ['ESTATUS3'],
  additionalEditableFields: ['OBSERVACION_CHOFER'],
  fieldEditRoles: {
    OBSERVACION_CHOFER: ['chofer', 'supervisor']
  },
  selectFieldOptions: ESTATUS2_SELECT_FIELD_OPTIONS
});

export default PendientesForaneoPage;
